import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useChat({ chatId }) {
  const [chat, setChat] = useState(null);

  const [shouldRefetch, setRefresh] = useState({});

  const refresh = () => {
    setRefresh({});
  };

  useEffect(() => {
    axios
      .get(routes.api.session_rooms.show(chatId))
      .then((response) => {
        setChat(response.data.data);
      });
  }, [chatId, shouldRefetch]);

  return { chat, refresh };
}
